import React from "react";
import { ProfileImages } from "../../../../common/styled/project";
import Preview from "./preview";

const CompanySelection = ({
  other,
  checked,
  handleCheckAll,
  handleIndividualCheck,
  imgHandler,
  fallbackImage,
  createGroup,
  handleAdd,
  renderProfileImages,
}) => {
  return (
    <>
      {other?.length > 0 && (
        <h4>
          <input
            type="checkbox"
            checked={checked.length === other.length}
            onChange={handleCheckAll}
          />
          <span>
            {checked.length === other.length ? "선택해제" : "전체선택"} ({checked.length}/
            {other.length}개)
          </span>
        </h4>
      )}
      <ul className="companies">
        {other.map((item) => (
          <li key={item.orgNo}>
            <input
              type="checkbox"
              checked={checked.some((c) => c.orgNo === item.orgNo)}
              onChange={(e) => handleIndividualCheck(item, e.target.checked)}
            />
            <ProfileImages>
              <div className="one">
                <img
                  src={imgHandler(item.orgImg)}
                  onError={(e) => (e.target.src = fallbackImage)}
                  alt={item.orgNm}
                />
              </div>
            </ProfileImages>
            <span>{item.orgNm}</span>
          </li>
        ))}
      </ul>
      <Preview
        createGroup={createGroup}
        checked={checked}
        handleAdd={handleAdd}
        renderProfileImages={renderProfileImages}
      />
    </>
  );
};

export default CompanySelection;
